import React from "react";
import InputField from "../../FormFields/InputField";

const MessageA14C = (props) => {
  return (
    <div style={{ width: "90%", margin: "0 auto" }}>
      <InputField {...props} flow="email" />
    </div>
  );
};

export default MessageA14C;
